import { rootApi as api } from '../rootApi';
export const addTagTypes = ['FMSettings'] as const;
const injectedRtkApi = api
    .enhanceEndpoints({
        addTagTypes,
    })
    .injectEndpoints({
        endpoints: build => ({
            postApiFmFmsettings: build.mutation<
                PostApiFmFmsettingsApiResponse,
                PostApiFmFmsettingsApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/fmsettings`,
                    method: 'POST',
                    body: queryArg.feedlotManagerModelsFmSettingModel,
                }),
                invalidatesTags: ['FMSettings'],
            }),
            getApiFmFmsettings: build.query<
                GetApiFmFmsettingsApiResponse,
                GetApiFmFmsettingsApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/fmsettings`,
                    params: {
                        include: queryArg.include,
                        filter: queryArg.filter,
                        sort: queryArg.sort,
                        limit: queryArg.limit,
                        offset: queryArg.offset,
                    },
                }),
                providesTags: ['FMSettings'],
            }),
            putApiFmFmsettingsById: build.mutation<
                PutApiFmFmsettingsByIdApiResponse,
                PutApiFmFmsettingsByIdApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/fmsettings/${queryArg.id}`,
                    method: 'PUT',
                    body: queryArg.feedlotManagerModelsFmSettingModel,
                }),
                invalidatesTags: ['FMSettings'],
            }),
            getApiFmFmsettingsById: build.query<
                GetApiFmFmsettingsByIdApiResponse,
                GetApiFmFmsettingsByIdApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/fmsettings/${queryArg.id}`,
                }),
                providesTags: ['FMSettings'],
            }),
            deleteApiFmFmsettingsById: build.mutation<
                DeleteApiFmFmsettingsByIdApiResponse,
                DeleteApiFmFmsettingsByIdApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/fmsettings/${queryArg.id}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['FMSettings'],
            }),
            getApiFmFmsettingsNamesByName: build.query<
                GetApiFmFmsettingsNamesByNameApiResponse,
                GetApiFmFmsettingsNamesByNameApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/fmsettings/names/${queryArg.name}`,
                }),
                providesTags: ['FMSettings'],
            }),
            getApiFmByFlidFmsettingsNamesAndName: build.query<
                GetApiFmByFlidFmsettingsNamesAndNameApiResponse,
                GetApiFmByFlidFmsettingsNamesAndNameApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/${queryArg.flid}/fmsettings/names/${queryArg.name}`,
                }),
                providesTags: ['FMSettings'],
            }),
            getApiFmFmsettingsOdata: build.query<
                GetApiFmFmsettingsOdataApiResponse,
                GetApiFmFmsettingsOdataApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/fmsettings/odata`,
                    params: {
                        include: queryArg.include,
                        queryOptions: queryArg.queryOptions,
                    },
                }),
                providesTags: ['FMSettings'],
            }),
            putApiFmFmsettingsLogging: build.mutation<
                PutApiFmFmsettingsLoggingApiResponse,
                PutApiFmFmsettingsLoggingApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/fmsettings/logging`,
                    method: 'PUT',
                    params: {
                        errorCodeFilter: queryArg.errorCodeFilter,
                        tenantFilter: queryArg.tenantFilter,
                        userFilter: queryArg.userFilter,
                        excludeFilter: queryArg.excludeFilter,
                        requestFilter: queryArg.requestFilter,
                        requestPayloadFilter: queryArg.requestPayloadFilter,
                        responsePayloadFilter: queryArg.responsePayloadFilter,
                        requestPayloadLimit: queryArg.requestPayloadLimit,
                        responsePayloadLimit: queryArg.responsePayloadLimit,
                    },
                }),
                invalidatesTags: ['FMSettings'],
            }),
        }),
        overrideExisting: false,
    });
export { injectedRtkApi as baseFMSettingsApi };
export type PostApiFmFmsettingsApiResponse = /** status 200 OK */ number;
export type PostApiFmFmsettingsApiArg = {
    feedlotManagerModelsFmSettingModel: FeedlotManagerModelsFmSettingModel;
};
export type GetApiFmFmsettingsApiResponse =
    /** status 200 OK */ FeedlotManagerModelsFmSettingModel[];
export type GetApiFmFmsettingsApiArg = {
    include?: string;
    filter?: string;
    sort?: string[];
    limit?: number;
    offset?: number;
};
export type PutApiFmFmsettingsByIdApiResponse = /** status 200 OK */ number;
export type PutApiFmFmsettingsByIdApiArg = {
    id: number;
    feedlotManagerModelsFmSettingModel: FeedlotManagerModelsFmSettingModel;
};
export type GetApiFmFmsettingsByIdApiResponse =
    /** status 200 OK */ FeedlotManagerModelsFmSettingModel;
export type GetApiFmFmsettingsByIdApiArg = {
    id: number;
};
export type DeleteApiFmFmsettingsByIdApiResponse = /** status 200 OK */ number;
export type DeleteApiFmFmsettingsByIdApiArg = {
    id: number;
};
export type GetApiFmFmsettingsNamesByNameApiResponse =
    /** status 200 OK */ FeedlotManagerModelsFmSettingModel;
export type GetApiFmFmsettingsNamesByNameApiArg = {
    name: string;
};
export type GetApiFmByFlidFmsettingsNamesAndNameApiResponse =
    /** status 200 OK */ FeedlotManagerModelsFmSettingModel;
export type GetApiFmByFlidFmsettingsNamesAndNameApiArg = {
    flid: number;
    name: string;
};
export type GetApiFmFmsettingsOdataApiResponse =
    /** status 200 OK */ FeedlotManagerModelsFmSettingModel[];
export type GetApiFmFmsettingsOdataApiArg = {
    include?: string;
    queryOptions?: MicrosoftAspNetCoreODataQueryODataQueryOptions601FeedlotManagerDataEntitiesFmSetting;
};
export type PutApiFmFmsettingsLoggingApiResponse = /** status 200 OK */ number;
export type PutApiFmFmsettingsLoggingApiArg = {
    errorCodeFilter?: string;
    tenantFilter?: string;
    userFilter?: string;
    excludeFilter?: string;
    requestFilter?: string;
    requestPayloadFilter?: string;
    responsePayloadFilter?: string;
    requestPayloadLimit?: number;
    responsePayloadLimit?: number;
};
export type CcCommonApIsModelsAddressInfoModel = {
    address1?: string | null;
    address2?: string | null;
    addressId?: number;
    city?: string | null;
    coordinates?: string | null;
    country?: string | null;
    postalCode?: string | null;
    state?: string | null;
};
export type CcCommonApIsModelsLocationModel = {
    addressId?: number;
    addressInfo?: CcCommonApIsModelsAddressInfoModel;
    altContactNumber?: string | null;
    altEmail?: string | null;
    contactName?: string | null;
    contactNumber?: string | null;
    email?: string | null;
    id?: number;
    isActive?: boolean;
    moduleName?: string | null;
    name?: string | null;
};
export type FeedlotManagerModelsFmFeedlotModel = {
    feedLotId?: number;
    feedLotSubscriptionId?: number | null;
    isInactive?: boolean | null;
    label?: string | null;
    labelColorHex?: string | null;
    location?: CcCommonApIsModelsLocationModel;
    locationId?: number;
    manager?: string | null;
    yardageRate?: number | null;
};
export type FeedlotManagerDataEnumsFmSettingNameEnum =
    | 'BaseMetric'
    | 'InjectionSystemName'
    | 'InjectionSystemName2'
    | 'InjectionSystemName3'
    | 'InjectionSystemName4'
    | 'InjectionSystemEnabled'
    | 'InjectionSystemEnabled2'
    | 'InjectionSystemEnabled3'
    | 'InjectionSystemEnabled4'
    | 'InjectionSystemCmdTopic'
    | 'InjectionSystemStatusTopic'
    | 'InjectionSystemCmdTopic2'
    | 'InjectionSystemStatusTopic2'
    | 'InjectionSystemCmdTopic3'
    | 'InjectionSystemStatusTopic3'
    | 'InjectionSystemCmdTopic4'
    | 'InjectionSystemStatusTopic4'
    | 'MaxFeedRecordDaysForHospitalAndBuller'
    | 'ReverseFeedCallRoute'
    | 'QuickBooksIntegration'
    | 'EnableNemNegOnCommodity';
export type FeedlotManagerModelsFmSettingModel = {
    feedlot?: FeedlotManagerModelsFmFeedlotModel;
    feedlotId?: number | null;
    fmSettingId?: number;
    name?: FeedlotManagerDataEnumsFmSettingNameEnum;
    value?: string | null;
};
export type MicrosoftODataUriParserAggregationTransformationNodeKind =
    | 'Aggregate'
    | 'GroupBy'
    | 'Filter'
    | 'Compute'
    | 'Expand';
export type MicrosoftODataUriParserAggregationTransformationNode = {
    kind?: MicrosoftODataUriParserAggregationTransformationNodeKind;
};
export type MicrosoftODataUriParserAggregationApplyClause = {
    transformations?:
        | MicrosoftODataUriParserAggregationTransformationNode[]
        | null;
};
export type MicrosoftAspNetCoreODataQueryDefaultQueryConfigurations = {
    enableCount?: boolean;
    enableExpand?: boolean;
    enableFilter?: boolean;
    enableOrderBy?: boolean;
    enableSelect?: boolean;
    enableSkipToken?: boolean;
    maxTop?: number | null;
};
export type SystemReflectionMethodAttributes =
    | 'PrivateScope'
    | 'Private'
    | 'FamANDAssem'
    | 'Assembly'
    | 'Family'
    | 'FamORAssem'
    | 'Public'
    | 'MemberAccessMask'
    | 'UnmanagedExport'
    | 'Static'
    | 'Final'
    | 'Virtual'
    | 'HideBySig'
    | 'NewSlot'
    | 'CheckAccessOnOverride'
    | 'Abstract'
    | 'SpecialName'
    | 'RTSpecialName'
    | 'PinvokeImpl'
    | 'HasSecurity'
    | 'RequireSecObject'
    | 'ReservedMask';
export type SystemReflectionCallingConventions =
    | 'Standard'
    | 'VarArgs'
    | 'Any'
    | 'HasThis'
    | 'ExplicitThis';
export type SystemReflectionMemberTypes =
    | 'Constructor'
    | 'Event'
    | 'Field'
    | 'Method'
    | 'Property'
    | 'TypeInfo'
    | 'Custom'
    | 'NestedType'
    | 'All';
export type SystemIntPtr = object;
export type SystemRuntimeMethodHandle = {
    value?: SystemIntPtr;
};
export type SystemReflectionMethodImplAttributes =
    | 'IL'
    | 'Native'
    | 'OPTIL'
    | 'CodeTypeMask'
    | 'ManagedMask'
    | 'NoInlining'
    | 'ForwardRef'
    | 'Synchronized'
    | 'NoOptimization'
    | 'PreserveSig'
    | 'AggressiveInlining'
    | 'AggressiveOptimization'
    | 'InternalCall'
    | 'MaxMethodImplVal';
export type SystemModuleHandle = {};
export type SystemModuleHandleRead = {
    mdStreamVersion?: number;
};
export type SystemReflectionModule = {
    assembly?: SystemReflectionAssembly;
    moduleHandle?: SystemModuleHandle;
};
export type SystemReflectionConstructorInfo = {
    attributes?: SystemReflectionMethodAttributes;
    callingConvention?: SystemReflectionCallingConventions;
    declaringType?: SystemType;
    memberType?: SystemReflectionMemberTypes;
    methodHandle?: SystemRuntimeMethodHandle;
    methodImplementationFlags?: SystemReflectionMethodImplAttributes;
    module?: SystemReflectionModule;
    reflectedType?: SystemType;
};
export type SystemReflectionConstructorInfoRead = {
    attributes?: SystemReflectionMethodAttributes;
    callingConvention?: SystemReflectionCallingConventions;
    containsGenericParameters?: boolean;
    customAttributes?: SystemReflectionCustomAttributeData[] | null;
    declaringType?: SystemType;
    isAbstract?: boolean;
    isAssembly?: boolean;
    isCollectible?: boolean;
    isConstructedGenericMethod?: boolean;
    isConstructor?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isFinal?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    isHideBySig?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    memberType?: SystemReflectionMemberTypes;
    metadataToken?: number;
    methodHandle?: SystemRuntimeMethodHandle;
    methodImplementationFlags?: SystemReflectionMethodImplAttributes;
    module?: SystemReflectionModuleRead;
    name?: string | null;
    reflectedType?: SystemType;
};
export type SystemReflectionCustomAttributeData = {
    attributeType?: SystemType;
    constructor?: SystemReflectionConstructorInfo;
};
export type SystemReflectionCustomAttributeTypedArgument = {
    argumentType?: SystemType;
    value?: any | null;
};
export type SystemReflectionCustomAttributeTypedArgumentRead = {
    argumentType?: SystemType;
    value?: any | null;
};
export type SystemReflectionMemberInfo = {
    declaringType?: SystemType;
    memberType?: SystemReflectionMemberTypes;
    module?: SystemReflectionModule;
    reflectedType?: SystemType;
};
export type SystemReflectionMemberInfoRead = {
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    declaringType?: SystemType;
    isCollectible?: boolean;
    memberType?: SystemReflectionMemberTypes;
    metadataToken?: number;
    module?: SystemReflectionModuleRead;
    name?: string | null;
    reflectedType?: SystemType;
};
export type SystemReflectionCustomAttributeNamedArgument = {
    memberInfo?: SystemReflectionMemberInfo;
    typedValue?: SystemReflectionCustomAttributeTypedArgument;
};
export type SystemReflectionCustomAttributeNamedArgumentRead = {
    isField?: boolean;
    memberInfo?: SystemReflectionMemberInfoRead;
    memberName?: string | null;
    typedValue?: SystemReflectionCustomAttributeTypedArgumentRead;
};
export type SystemReflectionCustomAttributeDataRead = {
    attributeType?: SystemType;
    constructor?: SystemReflectionConstructorInfoRead;
    constructorArguments?:
        | SystemReflectionCustomAttributeTypedArgumentRead[]
        | null;
    namedArguments?: SystemReflectionCustomAttributeNamedArgumentRead[] | null;
};
export type SystemReflectionModuleRead = {
    assembly?: SystemReflectionAssembly;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    fullyQualifiedName?: string | null;
    mdStreamVersion?: number;
    metadataToken?: number;
    moduleHandle?: SystemModuleHandleRead;
    moduleVersionId?: string;
    name?: string | null;
    scopeName?: string | null;
};
export type SystemReflectionParameterAttributes =
    | 'None'
    | 'In'
    | 'Out'
    | 'Lcid'
    | 'Retval'
    | 'Optional'
    | 'HasDefault'
    | 'HasFieldMarshal'
    | 'Reserved3'
    | 'Reserved4'
    | 'ReservedMask';
export type SystemReflectionParameterInfo = {
    attributes?: SystemReflectionParameterAttributes;
    member?: SystemReflectionMemberInfo;
    parameterType?: SystemType;
};
export type SystemReflectionParameterInfoRead = {
    attributes?: SystemReflectionParameterAttributes;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    defaultValue?: any | null;
    hasDefaultValue?: boolean;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    member?: SystemReflectionMemberInfoRead;
    metadataToken?: number;
    name?: string | null;
    parameterType?: SystemType;
    position?: number;
    rawDefaultValue?: any | null;
};
export type SystemReflectionICustomAttributeProvider = object;
export type SystemReflectionMethodInfo = {
    attributes?: SystemReflectionMethodAttributes;
    callingConvention?: SystemReflectionCallingConventions;
    declaringType?: SystemType;
    memberType?: SystemReflectionMemberTypes;
    methodHandle?: SystemRuntimeMethodHandle;
    methodImplementationFlags?: SystemReflectionMethodImplAttributes;
    module?: SystemReflectionModule;
    reflectedType?: SystemType;
    returnParameter?: SystemReflectionParameterInfo;
    returnType?: SystemType;
    returnTypeCustomAttributes?: SystemReflectionICustomAttributeProvider;
};
export type SystemReflectionMethodInfoRead = {
    attributes?: SystemReflectionMethodAttributes;
    callingConvention?: SystemReflectionCallingConventions;
    containsGenericParameters?: boolean;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    declaringType?: SystemType;
    isAbstract?: boolean;
    isAssembly?: boolean;
    isCollectible?: boolean;
    isConstructedGenericMethod?: boolean;
    isConstructor?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isFinal?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    isHideBySig?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    memberType?: SystemReflectionMemberTypes;
    metadataToken?: number;
    methodHandle?: SystemRuntimeMethodHandle;
    methodImplementationFlags?: SystemReflectionMethodImplAttributes;
    module?: SystemReflectionModuleRead;
    name?: string | null;
    reflectedType?: SystemType;
    returnParameter?: SystemReflectionParameterInfoRead;
    returnType?: SystemType;
    returnTypeCustomAttributes?: SystemReflectionICustomAttributeProvider;
};
export type SystemSecuritySecurityRuleSet = 'None' | 'Level1' | 'Level2';
export type SystemReflectionAssembly = {
    entryPoint?: SystemReflectionMethodInfo;
    manifestModule?: SystemReflectionModule;
    securityRuleSet?: SystemSecuritySecurityRuleSet;
};
export type SystemReflectionTypeAttributes =
    | 'NotPublic'
    | 'Public'
    | 'NestedPublic'
    | 'NestedPrivate'
    | 'NestedFamily'
    | 'NestedAssembly'
    | 'NestedFamANDAssem'
    | 'VisibilityMask'
    | 'SequentialLayout'
    | 'ExplicitLayout'
    | 'LayoutMask'
    | 'Interface'
    | 'Abstract'
    | 'Sealed'
    | 'SpecialName'
    | 'RTSpecialName'
    | 'Import'
    | 'Serializable'
    | 'WindowsRuntime'
    | 'UnicodeClass'
    | 'AutoClass'
    | 'StringFormatMask'
    | 'HasSecurity'
    | 'ReservedMask'
    | 'BeforeFieldInit'
    | 'CustomFormatMask';
export type SystemReflectionMethodBase = {
    attributes?: SystemReflectionMethodAttributes;
    callingConvention?: SystemReflectionCallingConventions;
    declaringType?: SystemType;
    memberType?: SystemReflectionMemberTypes;
    methodHandle?: SystemRuntimeMethodHandle;
    methodImplementationFlags?: SystemReflectionMethodImplAttributes;
    module?: SystemReflectionModule;
    reflectedType?: SystemType;
};
export type SystemReflectionMethodBaseRead = {
    attributes?: SystemReflectionMethodAttributes;
    callingConvention?: SystemReflectionCallingConventions;
    containsGenericParameters?: boolean;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    declaringType?: SystemType;
    isAbstract?: boolean;
    isAssembly?: boolean;
    isCollectible?: boolean;
    isConstructedGenericMethod?: boolean;
    isConstructor?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isFinal?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    isHideBySig?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    memberType?: SystemReflectionMemberTypes;
    metadataToken?: number;
    methodHandle?: SystemRuntimeMethodHandle;
    methodImplementationFlags?: SystemReflectionMethodImplAttributes;
    module?: SystemReflectionModuleRead;
    name?: string | null;
    reflectedType?: SystemType;
};
export type SystemReflectionGenericParameterAttributes =
    | 'None'
    | 'Covariant'
    | 'Contravariant'
    | 'VarianceMask'
    | 'ReferenceTypeConstraint'
    | 'NotNullableValueTypeConstraint'
    | 'DefaultConstructorConstraint'
    | 'SpecialConstraintMask';
export type SystemRuntimeInteropServicesLayoutKind =
    | 'Sequential'
    | 'Explicit'
    | 'Auto';
export type SystemRuntimeInteropServicesStructLayoutAttribute = {
    value?: SystemRuntimeInteropServicesLayoutKind;
};
export type SystemRuntimeInteropServicesStructLayoutAttributeRead = {
    typeId?: any | null;
    value?: SystemRuntimeInteropServicesLayoutKind;
};
export type SystemRuntimeTypeHandle = {
    value?: SystemIntPtr;
};
export type SystemReflectionTypeInfo = {
    assembly?: SystemReflectionAssembly;
    attributes?: SystemReflectionTypeAttributes;
    baseType?: SystemType;
    declaringMethod?: SystemReflectionMethodBase;
    declaringType?: SystemType;
    genericParameterAttributes?: SystemReflectionGenericParameterAttributes;
    memberType?: SystemReflectionMemberTypes;
    module?: SystemReflectionModule;
    reflectedType?: SystemType;
    structLayoutAttribute?: SystemRuntimeInteropServicesStructLayoutAttribute;
    typeHandle?: SystemRuntimeTypeHandle;
    typeInitializer?: SystemReflectionConstructorInfo;
    underlyingSystemType?: SystemType;
};
export type SystemReflectionEventAttributes =
    | 'None'
    | 'SpecialName'
    | 'RTSpecialName';
export type SystemReflectionEventInfo = {
    addMethod?: SystemReflectionMethodInfo;
    attributes?: SystemReflectionEventAttributes;
    declaringType?: SystemType;
    eventHandlerType?: SystemType;
    memberType?: SystemReflectionMemberTypes;
    module?: SystemReflectionModule;
    raiseMethod?: SystemReflectionMethodInfo;
    reflectedType?: SystemType;
    removeMethod?: SystemReflectionMethodInfo;
};
export type SystemReflectionEventInfoRead = {
    addMethod?: SystemReflectionMethodInfoRead;
    attributes?: SystemReflectionEventAttributes;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    declaringType?: SystemType;
    eventHandlerType?: SystemType;
    isCollectible?: boolean;
    isMulticast?: boolean;
    isSpecialName?: boolean;
    memberType?: SystemReflectionMemberTypes;
    metadataToken?: number;
    module?: SystemReflectionModuleRead;
    name?: string | null;
    raiseMethod?: SystemReflectionMethodInfoRead;
    reflectedType?: SystemType;
    removeMethod?: SystemReflectionMethodInfoRead;
};
export type SystemReflectionFieldAttributes =
    | 'PrivateScope'
    | 'Private'
    | 'FamANDAssem'
    | 'Assembly'
    | 'Family'
    | 'FamORAssem'
    | 'Public'
    | 'FieldAccessMask'
    | 'Static'
    | 'InitOnly'
    | 'Literal'
    | 'NotSerialized'
    | 'HasFieldRVA'
    | 'SpecialName'
    | 'RTSpecialName'
    | 'HasFieldMarshal'
    | 'PinvokeImpl'
    | 'HasDefault'
    | 'ReservedMask';
export type SystemRuntimeFieldHandle = {
    value?: SystemIntPtr;
};
export type SystemReflectionFieldInfo = {
    attributes?: SystemReflectionFieldAttributes;
    declaringType?: SystemType;
    fieldHandle?: SystemRuntimeFieldHandle;
    fieldType?: SystemType;
    memberType?: SystemReflectionMemberTypes;
    module?: SystemReflectionModule;
    reflectedType?: SystemType;
};
export type SystemReflectionFieldInfoRead = {
    attributes?: SystemReflectionFieldAttributes;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    declaringType?: SystemType;
    fieldHandle?: SystemRuntimeFieldHandle;
    fieldType?: SystemType;
    isAssembly?: boolean;
    isCollectible?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isInitOnly?: boolean;
    isLiteral?: boolean;
    isNotSerialized?: boolean;
    isPinvokeImpl?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    memberType?: SystemReflectionMemberTypes;
    metadataToken?: number;
    module?: SystemReflectionModuleRead;
    name?: string | null;
    reflectedType?: SystemType;
};
export type SystemReflectionPropertyAttributes =
    | 'None'
    | 'SpecialName'
    | 'RTSpecialName'
    | 'HasDefault'
    | 'Reserved2'
    | 'Reserved3'
    | 'Reserved4'
    | 'ReservedMask';
export type SystemReflectionPropertyInfo = {
    attributes?: SystemReflectionPropertyAttributes;
    declaringType?: SystemType;
    getMethod?: SystemReflectionMethodInfo;
    memberType?: SystemReflectionMemberTypes;
    module?: SystemReflectionModule;
    propertyType?: SystemType;
    reflectedType?: SystemType;
    setMethod?: SystemReflectionMethodInfo;
};
export type SystemReflectionPropertyInfoRead = {
    attributes?: SystemReflectionPropertyAttributes;
    canRead?: boolean;
    canWrite?: boolean;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    declaringType?: SystemType;
    getMethod?: SystemReflectionMethodInfoRead;
    isCollectible?: boolean;
    isSpecialName?: boolean;
    memberType?: SystemReflectionMemberTypes;
    metadataToken?: number;
    module?: SystemReflectionModuleRead;
    name?: string | null;
    propertyType?: SystemType;
    reflectedType?: SystemType;
    setMethod?: SystemReflectionMethodInfoRead;
};
export type SystemReflectionTypeInfoRead = {
    assembly?: SystemReflectionAssemblyRead;
    assemblyQualifiedName?: string | null;
    attributes?: SystemReflectionTypeAttributes;
    baseType?: SystemType;
    containsGenericParameters?: boolean;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    declaredConstructors?: SystemReflectionConstructorInfoRead[] | null;
    declaredEvents?: SystemReflectionEventInfoRead[] | null;
    declaredFields?: SystemReflectionFieldInfoRead[] | null;
    declaredMembers?: SystemReflectionMemberInfoRead[] | null;
    declaredMethods?: SystemReflectionMethodInfoRead[] | null;
    declaredNestedTypes?: SystemReflectionTypeInfoRead[] | null;
    declaredProperties?: SystemReflectionPropertyInfoRead[] | null;
    declaringMethod?: SystemReflectionMethodBaseRead;
    declaringType?: SystemType;
    fullName?: string | null;
    genericParameterAttributes?: SystemReflectionGenericParameterAttributes;
    genericParameterPosition?: number;
    genericTypeArguments?: SystemType[] | null;
    genericTypeParameters?: SystemType[] | null;
    guid?: string;
    hasElementType?: boolean;
    implementedInterfaces?: SystemType[] | null;
    isAbstract?: boolean;
    isAnsiClass?: boolean;
    isArray?: boolean;
    isAutoClass?: boolean;
    isAutoLayout?: boolean;
    isByRef?: boolean;
    isByRefLike?: boolean;
    isClass?: boolean;
    isCollectible?: boolean;
    isCOMObject?: boolean;
    isConstructedGenericType?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isExplicitLayout?: boolean;
    isFunctionPointer?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isGenericTypeParameter?: boolean;
    isImport?: boolean;
    isInterface?: boolean;
    isLayoutSequential?: boolean;
    isMarshalByRef?: boolean;
    isNested?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPointer?: boolean;
    isPrimitive?: boolean;
    isPublic?: boolean;
    isSealed?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    isSerializable?: boolean;
    isSignatureType?: boolean;
    isSpecialName?: boolean;
    isSZArray?: boolean;
    isTypeDefinition?: boolean;
    isUnicodeClass?: boolean;
    isUnmanagedFunctionPointer?: boolean;
    isValueType?: boolean;
    isVariableBoundArray?: boolean;
    isVisible?: boolean;
    memberType?: SystemReflectionMemberTypes;
    metadataToken?: number;
    module?: SystemReflectionModuleRead;
    name?: string | null;
    namespace?: string | null;
    reflectedType?: SystemType;
    structLayoutAttribute?: SystemRuntimeInteropServicesStructLayoutAttributeRead;
    typeHandle?: SystemRuntimeTypeHandle;
    typeInitializer?: SystemReflectionConstructorInfoRead;
    underlyingSystemType?: SystemType;
};
export type SystemReflectionAssemblyRead = {
    codeBase?: string | null;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    definedTypes?: SystemReflectionTypeInfoRead[] | null;
    entryPoint?: SystemReflectionMethodInfoRead;
    escapedCodeBase?: string | null;
    exportedTypes?: SystemType[] | null;
    fullName?: string | null;
    globalAssemblyCache?: boolean;
    hostContext?: number;
    imageRuntimeVersion?: string | null;
    isCollectible?: boolean;
    isDynamic?: boolean;
    isFullyTrusted?: boolean;
    location?: string | null;
    manifestModule?: SystemReflectionModuleRead;
    modules?: SystemReflectionModuleRead[] | null;
    reflectionOnly?: boolean;
    securityRuleSet?: SystemSecuritySecurityRuleSet;
};
export type SystemType = {
    assembly?: SystemReflectionAssembly;
    attributes?: SystemReflectionTypeAttributes;
    baseType?: SystemType;
    declaringMethod?: SystemReflectionMethodBase;
    declaringType?: SystemType;
    genericParameterAttributes?: SystemReflectionGenericParameterAttributes;
    memberType?: SystemReflectionMemberTypes;
    module?: SystemReflectionModule;
    reflectedType?: SystemType;
    structLayoutAttribute?: SystemRuntimeInteropServicesStructLayoutAttribute;
    typeHandle?: SystemRuntimeTypeHandle;
    typeInitializer?: SystemReflectionConstructorInfo;
    underlyingSystemType?: SystemType;
};
export type SystemTypeRead = {
    assembly?: SystemReflectionAssemblyRead;
    assemblyQualifiedName?: string | null;
    attributes?: SystemReflectionTypeAttributes;
    baseType?: SystemTypeRead;
    containsGenericParameters?: boolean;
    customAttributes?: SystemReflectionCustomAttributeDataRead[] | null;
    declaringMethod?: SystemReflectionMethodBaseRead;
    declaringType?: SystemTypeRead;
    fullName?: string | null;
    genericParameterAttributes?: SystemReflectionGenericParameterAttributes;
    genericParameterPosition?: number;
    genericTypeArguments?: SystemTypeRead[] | null;
    guid?: string;
    hasElementType?: boolean;
    isAbstract?: boolean;
    isAnsiClass?: boolean;
    isArray?: boolean;
    isAutoClass?: boolean;
    isAutoLayout?: boolean;
    isByRef?: boolean;
    isByRefLike?: boolean;
    isClass?: boolean;
    isCollectible?: boolean;
    isCOMObject?: boolean;
    isConstructedGenericType?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isExplicitLayout?: boolean;
    isFunctionPointer?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isGenericTypeParameter?: boolean;
    isImport?: boolean;
    isInterface?: boolean;
    isLayoutSequential?: boolean;
    isMarshalByRef?: boolean;
    isNested?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPointer?: boolean;
    isPrimitive?: boolean;
    isPublic?: boolean;
    isSealed?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    isSerializable?: boolean;
    isSignatureType?: boolean;
    isSpecialName?: boolean;
    isSZArray?: boolean;
    isTypeDefinition?: boolean;
    isUnicodeClass?: boolean;
    isUnmanagedFunctionPointer?: boolean;
    isValueType?: boolean;
    isVariableBoundArray?: boolean;
    isVisible?: boolean;
    memberType?: SystemReflectionMemberTypes;
    metadataToken?: number;
    module?: SystemReflectionModuleRead;
    name?: string | null;
    namespace?: string | null;
    reflectedType?: SystemTypeRead;
    structLayoutAttribute?: SystemRuntimeInteropServicesStructLayoutAttributeRead;
    typeHandle?: SystemRuntimeTypeHandle;
    typeInitializer?: SystemReflectionConstructorInfoRead;
    underlyingSystemType?: SystemTypeRead;
};
export type MicrosoftODataEdmEdmTypeKind =
    | 'None'
    | 'Primitive'
    | 'Entity'
    | 'Complex'
    | 'Collection'
    | 'EntityReference'
    | 'Enum'
    | 'TypeDefinition'
    | 'Untyped'
    | 'Path';
export type MicrosoftODataEdmIEdmType = {
    typeKind?: MicrosoftODataEdmEdmTypeKind;
};
export type MicrosoftODataEdmVocabulariesIEdmDirectValueAnnotationsManager =
    object;
export type MicrosoftODataEdmEdmSchemaElementKind =
    | 'None'
    | 'TypeDefinition'
    | 'Term'
    | 'Action'
    | 'EntityContainer'
    | 'Function';
export type MicrosoftODataEdmIEdmEntityContainer = {
    schemaElementKind?: MicrosoftODataEdmEdmSchemaElementKind;
};
export type MicrosoftODataEdmEdmContainerElementKind =
    | 'None'
    | 'EntitySet'
    | 'ActionImport'
    | 'FunctionImport'
    | 'Singleton';
export type MicrosoftODataEdmIEdmEntityContainerElement = {
    container?: MicrosoftODataEdmIEdmEntityContainer;
    containerElementKind?: MicrosoftODataEdmEdmContainerElementKind;
};
export type MicrosoftODataEdmIEdmEntityContainerElementRead = {
    container?: MicrosoftODataEdmIEdmEntityContainerRead;
    containerElementKind?: MicrosoftODataEdmEdmContainerElementKind;
    name?: string | null;
};
export type MicrosoftODataEdmIEdmEntityContainerRead = {
    elements?: MicrosoftODataEdmIEdmEntityContainerElementRead[] | null;
    name?: string | null;
    namespace?: string | null;
    schemaElementKind?: MicrosoftODataEdmEdmSchemaElementKind;
};
export type MicrosoftODataEdmIEdmModel = {
    directValueAnnotationsManager?: MicrosoftODataEdmVocabulariesIEdmDirectValueAnnotationsManager;
    entityContainer?: MicrosoftODataEdmIEdmEntityContainer;
};
export type MicrosoftODataEdmIEdmSchemaElement = {
    schemaElementKind?: MicrosoftODataEdmEdmSchemaElementKind;
};
export type MicrosoftODataEdmIEdmSchemaElementRead = {
    name?: string | null;
    namespace?: string | null;
    schemaElementKind?: MicrosoftODataEdmEdmSchemaElementKind;
};
export type MicrosoftODataEdmVocabulariesIEdmVocabularyAnnotatable = object;
export type MicrosoftODataEdmIEdmTypeReference = {
    definition?: MicrosoftODataEdmIEdmType;
};
export type MicrosoftODataEdmIEdmTypeReferenceRead = {
    definition?: MicrosoftODataEdmIEdmType;
    isNullable?: boolean;
};
export type MicrosoftODataEdmVocabulariesIEdmTerm = {
    schemaElementKind?: MicrosoftODataEdmEdmSchemaElementKind;
    type?: MicrosoftODataEdmIEdmTypeReference;
};
export type MicrosoftODataEdmVocabulariesIEdmTermRead = {
    appliesTo?: string | null;
    defaultValue?: string | null;
    name?: string | null;
    namespace?: string | null;
    schemaElementKind?: MicrosoftODataEdmEdmSchemaElementKind;
    type?: MicrosoftODataEdmIEdmTypeReferenceRead;
};
export type MicrosoftODataEdmEdmExpressionKind =
    | 'None'
    | 'BinaryConstant'
    | 'BooleanConstant'
    | 'DateTimeOffsetConstant'
    | 'DecimalConstant'
    | 'FloatingConstant'
    | 'GuidConstant'
    | 'IntegerConstant'
    | 'StringConstant'
    | 'DurationConstant'
    | 'Null'
    | 'Record'
    | 'Collection'
    | 'Path'
    | 'If'
    | 'Cast'
    | 'IsType'
    | 'FunctionApplication'
    | 'LabeledExpressionReference'
    | 'Labeled'
    | 'PropertyPath'
    | 'NavigationPropertyPath'
    | 'DateConstant'
    | 'TimeOfDayConstant'
    | 'EnumMember'
    | 'AnnotationPath';
export type MicrosoftODataEdmIEdmExpression = {
    expressionKind?: MicrosoftODataEdmEdmExpressionKind;
};
export type MicrosoftODataEdmVocabulariesIEdmVocabularyAnnotation = {
    target?: MicrosoftODataEdmVocabulariesIEdmVocabularyAnnotatable;
    term?: MicrosoftODataEdmVocabulariesIEdmTerm;
    value?: MicrosoftODataEdmIEdmExpression;
};
export type MicrosoftODataEdmVocabulariesIEdmVocabularyAnnotationRead = {
    qualifier?: string | null;
    target?: MicrosoftODataEdmVocabulariesIEdmVocabularyAnnotatable;
    term?: MicrosoftODataEdmVocabulariesIEdmTermRead;
    value?: MicrosoftODataEdmIEdmExpression;
};
export type MicrosoftODataEdmIEdmModelRead = {
    declaredNamespaces?: string[] | null;
    directValueAnnotationsManager?: MicrosoftODataEdmVocabulariesIEdmDirectValueAnnotationsManager;
    entityContainer?: MicrosoftODataEdmIEdmEntityContainerRead;
    referencedModels?: MicrosoftODataEdmIEdmModelRead[] | null;
    schemaElements?: MicrosoftODataEdmIEdmSchemaElementRead[] | null;
    vocabularyAnnotations?:
        | MicrosoftODataEdmVocabulariesIEdmVocabularyAnnotationRead[]
        | null;
};
export type MicrosoftODataEdmIEdmPathExpression = {
    expressionKind?: MicrosoftODataEdmEdmExpressionKind;
};
export type MicrosoftODataEdmIEdmPathExpressionRead = {
    expressionKind?: MicrosoftODataEdmEdmExpressionKind;
    path?: string | null;
    pathSegments?: string[] | null;
};
export type MicrosoftODataEdmIEdmNavigationSource = {
    path?: MicrosoftODataEdmIEdmPathExpression;
    type?: MicrosoftODataEdmIEdmType;
};
export type MicrosoftODataEdmIEdmStructuredType = {
    baseType?: MicrosoftODataEdmIEdmStructuredType;
    typeKind?: MicrosoftODataEdmEdmTypeKind;
};
export type MicrosoftODataEdmEdmPropertyKind =
    | 'None'
    | 'Structural'
    | 'Navigation';
export type MicrosoftODataEdmIEdmProperty = {
    declaringType?: MicrosoftODataEdmIEdmStructuredType;
    propertyKind?: MicrosoftODataEdmEdmPropertyKind;
    type?: MicrosoftODataEdmIEdmTypeReference;
};
export type MicrosoftODataEdmIEdmPropertyRead = {
    declaringType?: MicrosoftODataEdmIEdmStructuredTypeRead;
    name?: string | null;
    propertyKind?: MicrosoftODataEdmEdmPropertyKind;
    type?: MicrosoftODataEdmIEdmTypeReferenceRead;
};
export type MicrosoftODataEdmIEdmStructuredTypeRead = {
    baseType?: MicrosoftODataEdmIEdmStructuredTypeRead;
    declaredProperties?: MicrosoftODataEdmIEdmPropertyRead[] | null;
    isAbstract?: boolean;
    isOpen?: boolean;
    typeKind?: MicrosoftODataEdmEdmTypeKind;
};
export type MicrosoftODataEdmEdmOnDeleteAction = 'None' | 'Cascade';
export type MicrosoftODataEdmIEdmReferentialConstraint = {};
export type MicrosoftODataEdmIEdmStructuralProperty = {
    declaringType?: MicrosoftODataEdmIEdmStructuredType;
    propertyKind?: MicrosoftODataEdmEdmPropertyKind;
    type?: MicrosoftODataEdmIEdmTypeReference;
};
export type MicrosoftODataEdmIEdmStructuralPropertyRead = {
    declaringType?: MicrosoftODataEdmIEdmStructuredTypeRead;
    defaultValueString?: string | null;
    name?: string | null;
    propertyKind?: MicrosoftODataEdmEdmPropertyKind;
    type?: MicrosoftODataEdmIEdmTypeReferenceRead;
};
export type MicrosoftODataEdmEdmReferentialConstraintPropertyPair = {
    dependentProperty?: MicrosoftODataEdmIEdmStructuralProperty;
    principalProperty?: MicrosoftODataEdmIEdmStructuralProperty;
};
export type MicrosoftODataEdmEdmReferentialConstraintPropertyPairRead = {
    dependentProperty?: MicrosoftODataEdmIEdmStructuralPropertyRead;
    principalProperty?: MicrosoftODataEdmIEdmStructuralPropertyRead;
};
export type MicrosoftODataEdmIEdmReferentialConstraintRead = {
    propertyPairs?:
        | MicrosoftODataEdmEdmReferentialConstraintPropertyPairRead[]
        | null;
};
export type MicrosoftODataEdmIEdmNavigationProperty = {
    declaringType?: MicrosoftODataEdmIEdmStructuredType;
    onDelete?: MicrosoftODataEdmEdmOnDeleteAction;
    partner?: MicrosoftODataEdmIEdmNavigationProperty;
    propertyKind?: MicrosoftODataEdmEdmPropertyKind;
    referentialConstraint?: MicrosoftODataEdmIEdmReferentialConstraint;
    type?: MicrosoftODataEdmIEdmTypeReference;
};
export type MicrosoftODataEdmIEdmNavigationPropertyRead = {
    containsTarget?: boolean;
    declaringType?: MicrosoftODataEdmIEdmStructuredTypeRead;
    name?: string | null;
    onDelete?: MicrosoftODataEdmEdmOnDeleteAction;
    partner?: MicrosoftODataEdmIEdmNavigationPropertyRead;
    propertyKind?: MicrosoftODataEdmEdmPropertyKind;
    referentialConstraint?: MicrosoftODataEdmIEdmReferentialConstraintRead;
    type?: MicrosoftODataEdmIEdmTypeReferenceRead;
};
export type MicrosoftODataEdmIEdmNavigationPropertyBinding = {
    navigationProperty?: MicrosoftODataEdmIEdmNavigationProperty;
    path?: MicrosoftODataEdmIEdmPathExpression;
    target?: MicrosoftODataEdmIEdmNavigationSource;
};
export type MicrosoftODataEdmIEdmNavigationPropertyBindingRead = {
    navigationProperty?: MicrosoftODataEdmIEdmNavigationPropertyRead;
    path?: MicrosoftODataEdmIEdmPathExpressionRead;
    target?: MicrosoftODataEdmIEdmNavigationSourceRead;
};
export type MicrosoftODataEdmIEdmNavigationSourceRead = {
    name?: string | null;
    navigationPropertyBindings?:
        | MicrosoftODataEdmIEdmNavigationPropertyBindingRead[]
        | null;
    path?: MicrosoftODataEdmIEdmPathExpressionRead;
    type?: MicrosoftODataEdmIEdmType;
};
export type MicrosoftODataUriParserODataPathSegment = {
    edmType?: MicrosoftODataEdmIEdmType;
    identifier?: string | null;
};
export type SystemIServiceProvider = object;
export type MicrosoftAspNetCoreODataQueryODataQueryContext = {
    defaultQueryConfigurations?: MicrosoftAspNetCoreODataQueryDefaultQueryConfigurations;
    elementClrType?: SystemType;
    elementType?: MicrosoftODataEdmIEdmType;
    model?: MicrosoftODataEdmIEdmModel;
    navigationSource?: MicrosoftODataEdmIEdmNavigationSource;
    path?: MicrosoftODataUriParserODataPathSegment[] | null;
    requestContainer?: SystemIServiceProvider;
};
export type MicrosoftAspNetCoreODataQueryODataQueryContextRead = {
    defaultQueryConfigurations?: MicrosoftAspNetCoreODataQueryDefaultQueryConfigurations;
    elementClrType?: SystemTypeRead;
    elementType?: MicrosoftODataEdmIEdmType;
    model?: MicrosoftODataEdmIEdmModelRead;
    navigationSource?: MicrosoftODataEdmIEdmNavigationSourceRead;
    path?: MicrosoftODataUriParserODataPathSegment[] | null;
    requestContainer?: SystemIServiceProvider;
};
export type MicrosoftAspNetCoreODataQueryApplyQueryOption = {
    applyClause?: MicrosoftODataUriParserAggregationApplyClause;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    rawValue?: string | null;
    resultClrType?: SystemType;
};
export type MicrosoftAspNetCoreODataQueryApplyQueryOptionRead = {
    applyClause?: MicrosoftODataUriParserAggregationApplyClause;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    rawValue?: string | null;
    resultClrType?: SystemTypeRead;
};
export type MicrosoftODataUriParserQueryNodeKind =
    | 'None'
    | 'Constant'
    | 'Convert'
    | 'NonResourceRangeVariableReference'
    | 'BinaryOperator'
    | 'UnaryOperator'
    | 'SingleValuePropertyAccess'
    | 'CollectionPropertyAccess'
    | 'SingleValueFunctionCall'
    | 'Any'
    | 'CollectionNavigationNode'
    | 'SingleNavigationNode'
    | 'SingleValueOpenPropertyAccess'
    | 'SingleResourceCast'
    | 'All'
    | 'CollectionResourceCast'
    | 'ResourceRangeVariableReference'
    | 'SingleResourceFunctionCall'
    | 'CollectionFunctionCall'
    | 'CollectionResourceFunctionCall'
    | 'NamedFunctionParameter'
    | 'ParameterAlias'
    | 'EntitySet'
    | 'KeyLookup'
    | 'SearchTerm'
    | 'CollectionOpenPropertyAccess'
    | 'CollectionComplexNode'
    | 'SingleComplexNode'
    | 'Count'
    | 'SingleValueCast'
    | 'CollectionPropertyNode'
    | 'AggregatedCollectionPropertyNode'
    | 'In'
    | 'CollectionConstant';
export type MicrosoftODataUriParserSingleValueNode = {
    kind?: MicrosoftODataUriParserQueryNodeKind;
    typeReference?: MicrosoftODataEdmIEdmTypeReference;
};
export type MicrosoftODataUriParserSingleValueNodeRead = {
    kind?: MicrosoftODataUriParserQueryNodeKind;
    typeReference?: MicrosoftODataEdmIEdmTypeReferenceRead;
};
export type MicrosoftODataUriParserComputeExpression = {
    alias?: string | null;
    expression?: MicrosoftODataUriParserSingleValueNode;
    typeReference?: MicrosoftODataEdmIEdmTypeReference;
};
export type MicrosoftODataUriParserComputeExpressionRead = {
    alias?: string | null;
    expression?: MicrosoftODataUriParserSingleValueNodeRead;
    typeReference?: MicrosoftODataEdmIEdmTypeReferenceRead;
};
export type MicrosoftODataUriParserComputeClause = {
    computedItems?: MicrosoftODataUriParserComputeExpression[] | null;
};
export type MicrosoftODataUriParserComputeClauseRead = {
    computedItems?: MicrosoftODataUriParserComputeExpressionRead[] | null;
};
export type MicrosoftAspNetCoreODataQueryValidatorIComputeQueryValidator =
    object;
export type MicrosoftAspNetCoreODataQueryComputeQueryOption = {
    computeClause?: MicrosoftODataUriParserComputeClause;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    rawValue?: string | null;
    resultClrType?: SystemType;
    validator?: MicrosoftAspNetCoreODataQueryValidatorIComputeQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryComputeQueryOptionRead = {
    computeClause?: MicrosoftODataUriParserComputeClauseRead;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    rawValue?: string | null;
    resultClrType?: SystemTypeRead;
    validator?: MicrosoftAspNetCoreODataQueryValidatorIComputeQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryValidatorICountQueryValidator = object;
export type MicrosoftAspNetCoreODataQueryCountQueryOption = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorICountQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryCountQueryOptionRead = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorICountQueryValidator;
    value?: boolean;
};
export type MicrosoftODataUriParserRangeVariable = {
    typeReference?: MicrosoftODataEdmIEdmTypeReference;
};
export type MicrosoftODataUriParserRangeVariableRead = {
    kind?: number;
    name?: string | null;
    typeReference?: MicrosoftODataEdmIEdmTypeReferenceRead;
};
export type MicrosoftODataUriParserFilterClause = {
    expression?: MicrosoftODataUriParserSingleValueNode;
    itemType?: MicrosoftODataEdmIEdmTypeReference;
    rangeVariable?: MicrosoftODataUriParserRangeVariable;
};
export type MicrosoftODataUriParserFilterClauseRead = {
    expression?: MicrosoftODataUriParserSingleValueNodeRead;
    itemType?: MicrosoftODataEdmIEdmTypeReferenceRead;
    rangeVariable?: MicrosoftODataUriParserRangeVariableRead;
};
export type MicrosoftAspNetCoreODataQueryValidatorIFilterQueryValidator =
    object;
export type MicrosoftAspNetCoreODataQueryFilterQueryOption = {
    compute?: MicrosoftAspNetCoreODataQueryComputeQueryOption;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    filterClause?: MicrosoftODataUriParserFilterClause;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorIFilterQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryFilterQueryOptionRead = {
    compute?: MicrosoftAspNetCoreODataQueryComputeQueryOptionRead;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    filterClause?: MicrosoftODataUriParserFilterClauseRead;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorIFilterQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryETag601FeedlotManagerDataEntitiesFmSetting =
    {
        entityType?: SystemType;
        isAny?: boolean;
        isIfNoneMatch?: boolean;
        isWellFormed?: boolean;
    };
export type MicrosoftAspNetCoreODataQueryETag601FeedlotManagerDataEntitiesFmSettingRead =
    {
        entityType?: SystemTypeRead;
        isAny?: boolean;
        isIfNoneMatch?: boolean;
        isWellFormed?: boolean;
    };
export type MicrosoftODataUriParserOrderByDirection =
    | 'Ascending'
    | 'Descending';
export type MicrosoftODataUriParserOrderByClause = {
    direction?: MicrosoftODataUriParserOrderByDirection;
    expression?: MicrosoftODataUriParserSingleValueNode;
    itemType?: MicrosoftODataEdmIEdmTypeReference;
    rangeVariable?: MicrosoftODataUriParserRangeVariable;
    thenBy?: MicrosoftODataUriParserOrderByClause;
};
export type MicrosoftODataUriParserOrderByClauseRead = {
    direction?: MicrosoftODataUriParserOrderByDirection;
    expression?: MicrosoftODataUriParserSingleValueNodeRead;
    itemType?: MicrosoftODataEdmIEdmTypeReferenceRead;
    rangeVariable?: MicrosoftODataUriParserRangeVariableRead;
    thenBy?: MicrosoftODataUriParserOrderByClauseRead;
};
export type MicrosoftAspNetCoreODataQueryValidatorIOrderByQueryValidator =
    object;
export type MicrosoftAspNetCoreODataQueryOrderByQueryOption = {
    compute?: MicrosoftAspNetCoreODataQueryComputeQueryOption;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    orderByClause?: MicrosoftODataUriParserOrderByClause;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorIOrderByQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryOrderByNode = {
    direction?: MicrosoftODataUriParserOrderByDirection;
};
export type MicrosoftAspNetCoreODataQueryOrderByQueryOptionRead = {
    compute?: MicrosoftAspNetCoreODataQueryComputeQueryOptionRead;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    orderByClause?: MicrosoftODataUriParserOrderByClauseRead;
    orderByNodes?: MicrosoftAspNetCoreODataQueryOrderByNode[] | null;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorIOrderByQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryODataRawQueryOptions = {};
export type MicrosoftAspNetCoreODataQueryODataRawQueryOptionsRead = {
    apply?: string | null;
    compute?: string | null;
    count?: string | null;
    deltaToken?: string | null;
    expand?: string | null;
    filter?: string | null;
    format?: string | null;
    orderBy?: string | null;
    search?: string | null;
    select?: string | null;
    skip?: string | null;
    skipToken?: string | null;
    top?: string | null;
};
export type SystemCollectionsGenericKeyValuePair602SystemStringSystemString = {
    key?: string | null;
    value?: string | null;
};
export type SystemCollectionsGenericKeyValuePair602SystemStringMicrosoftExtensionsPrimitivesStringValues =
    {
        key?: string | null;
        value?: string[];
    };
export type MicrosoftAspNetCoreHttpHostString = {
    value?: string | null;
};
export type MicrosoftAspNetCoreHttpHostStringRead = {
    hasValue?: boolean;
    host?: string | null;
    port?: number | null;
    value?: string | null;
};
export type SystemSecurityCryptographyOid = {
    friendlyName?: string | null;
    value?: string | null;
};
export type SystemSecurityCryptographyX509CertificatesX500DistinguishedName = {
    oid?: SystemSecurityCryptographyOid;
    rawData?: string | null;
};
export type SystemSecurityCryptographyX509CertificatesX500DistinguishedNameRead =
    {
        name?: string | null;
        oid?: SystemSecurityCryptographyOid;
        rawData?: string | null;
    };
export type SystemSecurityCryptographyAsymmetricAlgorithm = {
    keySize?: number;
};
export type SystemSecurityCryptographyKeySizes = {
    maxSize?: number;
    minSize?: number;
    skipSize?: number;
};
export type SystemSecurityCryptographyAsymmetricAlgorithmRead = {
    keyExchangeAlgorithm?: string | null;
    keySize?: number;
    legalKeySizes?: SystemSecurityCryptographyKeySizes[] | null;
    signatureAlgorithm?: string | null;
};
export type SystemSecurityCryptographyAsnEncodedData = {
    oid?: SystemSecurityCryptographyOid;
    rawData?: string | null;
};
export type SystemSecurityCryptographyX509CertificatesPublicKey = {
    encodedKeyValue?: SystemSecurityCryptographyAsnEncodedData;
    encodedParameters?: SystemSecurityCryptographyAsnEncodedData;
    key?: SystemSecurityCryptographyAsymmetricAlgorithm;
    oid?: SystemSecurityCryptographyOid;
};
export type SystemSecurityCryptographyX509CertificatesPublicKeyRead = {
    encodedKeyValue?: SystemSecurityCryptographyAsnEncodedData;
    encodedParameters?: SystemSecurityCryptographyAsnEncodedData;
    key?: SystemSecurityCryptographyAsymmetricAlgorithmRead;
    oid?: SystemSecurityCryptographyOid;
};
export type SystemReadOnlySpan601SystemByte = {};
export type SystemReadOnlySpan601SystemByteRead = {
    isEmpty?: boolean;
    length?: number;
};
export type SystemReadOnlyMemory601SystemByte = {
    span?: SystemReadOnlySpan601SystemByte;
};
export type SystemReadOnlyMemory601SystemByteRead = {
    isEmpty?: boolean;
    length?: number;
    span?: SystemReadOnlySpan601SystemByteRead;
};
export type SystemSecurityCryptographyX509CertificatesX509Certificate2 = {
    archived?: boolean;
    friendlyName?: string | null;
    handle?: SystemIntPtr;
    issuerName?: SystemSecurityCryptographyX509CertificatesX500DistinguishedName;
    privateKey?: SystemSecurityCryptographyAsymmetricAlgorithm;
    publicKey?: SystemSecurityCryptographyX509CertificatesPublicKey;
    rawDataMemory?: SystemReadOnlyMemory601SystemByte;
    serialNumberBytes?: SystemReadOnlyMemory601SystemByte;
    signatureAlgorithm?: SystemSecurityCryptographyOid;
    subjectName?: SystemSecurityCryptographyX509CertificatesX500DistinguishedName;
};
export type SystemSecurityCryptographyX509CertificatesX509Extension = {
    critical?: boolean;
    oid?: SystemSecurityCryptographyOid;
    rawData?: string | null;
};
export type SystemSecurityCryptographyX509CertificatesX509Certificate2Read = {
    archived?: boolean;
    extensions?:
        | SystemSecurityCryptographyX509CertificatesX509Extension[]
        | null;
    friendlyName?: string | null;
    handle?: SystemIntPtr;
    hasPrivateKey?: boolean;
    issuer?: string | null;
    issuerName?: SystemSecurityCryptographyX509CertificatesX500DistinguishedNameRead;
    notAfter?: string;
    notBefore?: string;
    privateKey?: SystemSecurityCryptographyAsymmetricAlgorithmRead;
    publicKey?: SystemSecurityCryptographyX509CertificatesPublicKeyRead;
    rawData?: string | null;
    rawDataMemory?: SystemReadOnlyMemory601SystemByteRead;
    serialNumber?: string | null;
    serialNumberBytes?: SystemReadOnlyMemory601SystemByteRead;
    signatureAlgorithm?: SystemSecurityCryptographyOid;
    subject?: string | null;
    subjectName?: SystemSecurityCryptographyX509CertificatesX500DistinguishedNameRead;
    thumbprint?: string | null;
    version?: number;
};
export type SystemNetSocketsAddressFamily =
    | 'Unspecified'
    | 'Unix'
    | 'InterNetwork'
    | 'ImpLink'
    | 'Pup'
    | 'Chaos'
    | 'NS'
    | 'Iso'
    | 'Ecma'
    | 'DataKit'
    | 'Ccitt'
    | 'Sna'
    | 'DecNet'
    | 'DataLink'
    | 'Lat'
    | 'HyperChannel'
    | 'AppleTalk'
    | 'NetBios'
    | 'VoiceView'
    | 'FireFox'
    | 'Banyan'
    | 'Atm'
    | 'InterNetworkV6'
    | 'Cluster'
    | 'Ieee12844'
    | 'Irda'
    | 'NetworkDesigners'
    | 'Max'
    | 'Packet'
    | 'ControllerAreaNetwork'
    | 'Unknown';
export type SystemNetIpAddress = {
    address?: number;
    addressFamily?: SystemNetSocketsAddressFamily;
    scopeId?: number;
};
export type SystemNetIpAddressRead = {
    address?: number;
    addressFamily?: SystemNetSocketsAddressFamily;
    isIPv4MappedToIPv6?: boolean;
    isIPv6LinkLocal?: boolean;
    isIPv6Multicast?: boolean;
    isIPv6SiteLocal?: boolean;
    isIPv6Teredo?: boolean;
    isIPv6UniqueLocal?: boolean;
    scopeId?: number;
};
export type MicrosoftAspNetCoreHttpConnectionInfo = {
    clientCertificate?: SystemSecurityCryptographyX509CertificatesX509Certificate2;
    id?: string | null;
    localIpAddress?: SystemNetIpAddress;
    localPort?: number;
    remoteIpAddress?: SystemNetIpAddress;
    remotePort?: number;
};
export type MicrosoftAspNetCoreHttpConnectionInfoRead = {
    clientCertificate?: SystemSecurityCryptographyX509CertificatesX509Certificate2Read;
    id?: string | null;
    localIpAddress?: SystemNetIpAddressRead;
    localPort?: number;
    remoteIpAddress?: SystemNetIpAddressRead;
    remotePort?: number;
};
export type MicrosoftWin32SafeHandlesSafeWaitHandle = {};
export type MicrosoftWin32SafeHandlesSafeWaitHandleRead = {
    isClosed?: boolean;
    isInvalid?: boolean;
};
export type SystemThreadingWaitHandle = {
    handle?: SystemIntPtr;
    safeWaitHandle?: MicrosoftWin32SafeHandlesSafeWaitHandle;
};
export type SystemThreadingWaitHandleRead = {
    handle?: SystemIntPtr;
    safeWaitHandle?: MicrosoftWin32SafeHandlesSafeWaitHandleRead;
};
export type SystemThreadingCancellationToken = {
    waitHandle?: SystemThreadingWaitHandle;
};
export type SystemThreadingCancellationTokenRead = {
    canBeCanceled?: boolean;
    isCancellationRequested?: boolean;
    waitHandle?: SystemThreadingWaitHandleRead;
};
export type SystemIoPipelinesPipeWriter = {};
export type SystemIoPipelinesPipeWriterRead = {
    canGetUnflushedBytes?: boolean;
    unflushedBytes?: number;
};
export type MicrosoftAspNetCoreHttpIResponseCookies = object;
export type MicrosoftAspNetCoreHttpHttpResponse = {
    body?: Blob | null;
    bodyWriter?: SystemIoPipelinesPipeWriter;
    contentLength?: number | null;
    contentType?: string | null;
    cookies?: MicrosoftAspNetCoreHttpIResponseCookies;
    httpContext?: MicrosoftAspNetCoreHttpHttpContext;
    statusCode?: number;
};
export type MicrosoftAspNetCoreHttpHttpResponseRead = {
    body?: Blob | null;
    bodyWriter?: SystemIoPipelinesPipeWriterRead;
    contentLength?: number | null;
    contentType?: string | null;
    cookies?: MicrosoftAspNetCoreHttpIResponseCookies;
    hasStarted?: boolean;
    headers?: {
        [key: string]: string[];
    } | null;
    httpContext?: MicrosoftAspNetCoreHttpHttpContext;
    statusCode?: number;
};
export type MicrosoftAspNetCoreHttpISession = {};
export type MicrosoftAspNetCoreHttpISessionRead = {
    id?: string | null;
    isAvailable?: boolean;
    keys?: string[] | null;
};
export type SystemSecurityPrincipalIIdentity = {};
export type SystemSecurityPrincipalIIdentityRead = {
    authenticationType?: string | null;
    isAuthenticated?: boolean;
    name?: string | null;
};
export type SystemSecurityClaimsClaimsPrincipal = {
    identity?: SystemSecurityPrincipalIIdentity;
};
export type SystemSecurityClaimsClaimsIdentity = {
    actor?: SystemSecurityClaimsClaimsIdentity;
    bootstrapContext?: any | null;
    label?: string | null;
};
export type SystemSecurityClaimsClaimsIdentityRead = {
    actor?: SystemSecurityClaimsClaimsIdentityRead;
    authenticationType?: string | null;
    bootstrapContext?: any | null;
    claims?: SystemSecurityClaimsClaim[] | null;
    isAuthenticated?: boolean;
    label?: string | null;
    name?: string | null;
    nameClaimType?: string | null;
    roleClaimType?: string | null;
};
export type SystemSecurityClaimsClaim = {
    subject?: SystemSecurityClaimsClaimsIdentity;
};
export type SystemSecurityClaimsClaimRead = {
    issuer?: string | null;
    originalIssuer?: string | null;
    properties?: {
        [key: string]: string;
    } | null;
    subject?: SystemSecurityClaimsClaimsIdentityRead;
    type?: string | null;
    value?: string | null;
    valueType?: string | null;
};
export type SystemSecurityClaimsClaimsPrincipalRead = {
    claims?: SystemSecurityClaimsClaimRead[] | null;
    identities?: SystemSecurityClaimsClaimsIdentityRead[] | null;
    identity?: SystemSecurityPrincipalIIdentityRead;
};
export type MicrosoftAspNetCoreHttpWebSocketManager = {};
export type MicrosoftAspNetCoreHttpWebSocketManagerRead = {
    isWebSocketRequest?: boolean;
    webSocketRequestedProtocols?: string[] | null;
};
export type MicrosoftAspNetCoreHttpHttpContext = {
    connection?: MicrosoftAspNetCoreHttpConnectionInfo;
    items?: {
        [key: string]: any | null;
    } | null;
    request?: MicrosoftAspNetCoreHttpHttpRequest;
    requestAborted?: SystemThreadingCancellationToken;
    requestServices?: SystemIServiceProvider;
    response?: MicrosoftAspNetCoreHttpHttpResponse;
    session?: MicrosoftAspNetCoreHttpISession;
    traceIdentifier?: string | null;
    user?: SystemSecurityClaimsClaimsPrincipal;
    webSockets?: MicrosoftAspNetCoreHttpWebSocketManager;
};
export type SystemCollectionsGenericKeyValuePair602SystemTypeSystemObject = {
    key?: SystemType;
    value?: any | null;
};
export type SystemCollectionsGenericKeyValuePair602SystemTypeSystemObjectRead =
    {
        key?: SystemTypeRead;
        value?: any | null;
    };
export type MicrosoftAspNetCoreHttpHttpContextRead = {
    connection?: MicrosoftAspNetCoreHttpConnectionInfoRead;
    features?:
        | SystemCollectionsGenericKeyValuePair602SystemTypeSystemObjectRead[]
        | null;
    items?: {
        [key: string]: any | null;
    } | null;
    request?: MicrosoftAspNetCoreHttpHttpRequest;
    requestAborted?: SystemThreadingCancellationTokenRead;
    requestServices?: SystemIServiceProvider;
    response?: MicrosoftAspNetCoreHttpHttpResponseRead;
    session?: MicrosoftAspNetCoreHttpISessionRead;
    traceIdentifier?: string | null;
    user?: SystemSecurityClaimsClaimsPrincipalRead;
    webSockets?: MicrosoftAspNetCoreHttpWebSocketManagerRead;
};
export type MicrosoftAspNetCoreHttpPathString = {
    value?: string | null;
};
export type MicrosoftAspNetCoreHttpPathStringRead = {
    hasValue?: boolean;
    value?: string | null;
};
export type MicrosoftAspNetCoreHttpQueryString = {
    value?: string | null;
};
export type MicrosoftAspNetCoreHttpQueryStringRead = {
    hasValue?: boolean;
    value?: string | null;
};
export type MicrosoftAspNetCoreHttpHttpRequest = {
    body?: Blob | null;
    contentLength?: number | null;
    contentType?: string | null;
    cookies?:
        | SystemCollectionsGenericKeyValuePair602SystemStringSystemString[]
        | null;
    form?:
        | SystemCollectionsGenericKeyValuePair602SystemStringMicrosoftExtensionsPrimitivesStringValues[]
        | null;
    host?: MicrosoftAspNetCoreHttpHostString;
    httpContext?: MicrosoftAspNetCoreHttpHttpContext;
    isHttps?: boolean;
    method?: string | null;
    path?: MicrosoftAspNetCoreHttpPathString;
    pathBase?: MicrosoftAspNetCoreHttpPathString;
    protocol?: string | null;
    query?:
        | SystemCollectionsGenericKeyValuePair602SystemStringMicrosoftExtensionsPrimitivesStringValues[]
        | null;
    queryString?: MicrosoftAspNetCoreHttpQueryString;
    routeValues?: {
        [key: string]: any;
    } | null;
    scheme?: string | null;
};
export type MicrosoftAspNetCoreHttpHttpRequestRead = {
    body?: Blob | null;
    bodyReader?: Blob | null;
    contentLength?: number | null;
    contentType?: string | null;
    cookies?:
        | SystemCollectionsGenericKeyValuePair602SystemStringSystemString[]
        | null;
    form?:
        | SystemCollectionsGenericKeyValuePair602SystemStringMicrosoftExtensionsPrimitivesStringValues[]
        | null;
    hasFormContentType?: boolean;
    headers?: {
        [key: string]: string[];
    } | null;
    host?: MicrosoftAspNetCoreHttpHostStringRead;
    httpContext?: MicrosoftAspNetCoreHttpHttpContextRead;
    isHttps?: boolean;
    method?: string | null;
    path?: MicrosoftAspNetCoreHttpPathStringRead;
    pathBase?: MicrosoftAspNetCoreHttpPathStringRead;
    protocol?: string | null;
    query?:
        | SystemCollectionsGenericKeyValuePair602SystemStringMicrosoftExtensionsPrimitivesStringValues[]
        | null;
    queryString?: MicrosoftAspNetCoreHttpQueryStringRead;
    routeValues?: {
        [key: string]: any;
    } | null;
    scheme?: string | null;
};
export type MicrosoftODataUriParserSearchClause = {
    expression?: MicrosoftODataUriParserSingleValueNode;
};
export type MicrosoftODataUriParserSearchClauseRead = {
    expression?: MicrosoftODataUriParserSingleValueNodeRead;
};
export type MicrosoftAspNetCoreODataQuerySearchQueryOption = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    rawValue?: string | null;
    resultClrType?: SystemType;
    searchClause?: MicrosoftODataUriParserSearchClause;
};
export type MicrosoftAspNetCoreODataQuerySearchQueryOptionRead = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    rawValue?: string | null;
    resultClrType?: SystemTypeRead;
    searchClause?: MicrosoftODataUriParserSearchClauseRead;
};
export type MicrosoftODataUriParserSelectItem = object;
export type MicrosoftODataUriParserSelectExpandClause = {
    allSelected?: boolean;
    selectedItems?: MicrosoftODataUriParserSelectItem[] | null;
};
export type MicrosoftAspNetCoreODataQueryValidatorISelectExpandQueryValidator =
    object;
export type MicrosoftAspNetCoreODataQuerySelectExpandQueryOption = {
    compute?: MicrosoftAspNetCoreODataQueryComputeQueryOption;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    levelsMaxLiteralExpansionDepth?: number;
    selectExpandClause?: MicrosoftODataUriParserSelectExpandClause;
    validator?: MicrosoftAspNetCoreODataQueryValidatorISelectExpandQueryValidator;
};
export type MicrosoftAspNetCoreODataQuerySelectExpandQueryOptionRead = {
    compute?: MicrosoftAspNetCoreODataQueryComputeQueryOptionRead;
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    levelsMaxLiteralExpansionDepth?: number;
    rawExpand?: string | null;
    rawSelect?: string | null;
    selectExpandClause?: MicrosoftODataUriParserSelectExpandClause;
    validator?: MicrosoftAspNetCoreODataQueryValidatorISelectExpandQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryValidatorISkipQueryValidator = object;
export type MicrosoftAspNetCoreODataQuerySkipQueryOption = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorISkipQueryValidator;
};
export type MicrosoftAspNetCoreODataQuerySkipQueryOptionRead = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorISkipQueryValidator;
    value?: number;
};
export type MicrosoftAspNetCoreODataQuerySkipTokenHandler = object;
export type MicrosoftAspNetCoreODataQueryValidatorISkipTokenQueryValidator =
    object;
export type MicrosoftAspNetCoreODataQuerySkipTokenQueryOption = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    handler?: MicrosoftAspNetCoreODataQuerySkipTokenHandler;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorISkipTokenQueryValidator;
};
export type MicrosoftAspNetCoreODataQuerySkipTokenQueryOptionRead = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    handler?: MicrosoftAspNetCoreODataQuerySkipTokenHandler;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorISkipTokenQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryValidatorITopQueryValidator = object;
export type MicrosoftAspNetCoreODataQueryTopQueryOption = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorITopQueryValidator;
};
export type MicrosoftAspNetCoreODataQueryTopQueryOptionRead = {
    context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
    rawValue?: string | null;
    validator?: MicrosoftAspNetCoreODataQueryValidatorITopQueryValidator;
    value?: number;
};
export type MicrosoftAspNetCoreODataQueryValidatorIoDataQueryValidator = object;
export type MicrosoftAspNetCoreODataQueryODataQueryOptions601FeedlotManagerDataEntitiesFmSetting =
    {
        apply?: MicrosoftAspNetCoreODataQueryApplyQueryOption;
        compute?: MicrosoftAspNetCoreODataQueryComputeQueryOption;
        context?: MicrosoftAspNetCoreODataQueryODataQueryContext;
        count?: MicrosoftAspNetCoreODataQueryCountQueryOption;
        filter?: MicrosoftAspNetCoreODataQueryFilterQueryOption;
        ifMatch?: MicrosoftAspNetCoreODataQueryETag601FeedlotManagerDataEntitiesFmSetting;
        ifNoneMatch?: MicrosoftAspNetCoreODataQueryETag601FeedlotManagerDataEntitiesFmSetting;
        orderBy?: MicrosoftAspNetCoreODataQueryOrderByQueryOption;
        rawValues?: MicrosoftAspNetCoreODataQueryODataRawQueryOptions;
        request?: MicrosoftAspNetCoreHttpHttpRequest;
        search?: MicrosoftAspNetCoreODataQuerySearchQueryOption;
        selectExpand?: MicrosoftAspNetCoreODataQuerySelectExpandQueryOption;
        skip?: MicrosoftAspNetCoreODataQuerySkipQueryOption;
        skipToken?: MicrosoftAspNetCoreODataQuerySkipTokenQueryOption;
        top?: MicrosoftAspNetCoreODataQueryTopQueryOption;
        validator?: MicrosoftAspNetCoreODataQueryValidatorIoDataQueryValidator;
    };
export type MicrosoftAspNetCoreODataQueryODataQueryOptions601FeedlotManagerDataEntitiesFmSettingRead =
    {
        apply?: MicrosoftAspNetCoreODataQueryApplyQueryOptionRead;
        compute?: MicrosoftAspNetCoreODataQueryComputeQueryOptionRead;
        context?: MicrosoftAspNetCoreODataQueryODataQueryContextRead;
        count?: MicrosoftAspNetCoreODataQueryCountQueryOptionRead;
        filter?: MicrosoftAspNetCoreODataQueryFilterQueryOptionRead;
        ifMatch?: MicrosoftAspNetCoreODataQueryETag601FeedlotManagerDataEntitiesFmSettingRead;
        ifNoneMatch?: MicrosoftAspNetCoreODataQueryETag601FeedlotManagerDataEntitiesFmSettingRead;
        orderBy?: MicrosoftAspNetCoreODataQueryOrderByQueryOptionRead;
        rawValues?: MicrosoftAspNetCoreODataQueryODataRawQueryOptionsRead;
        request?: MicrosoftAspNetCoreHttpHttpRequestRead;
        search?: MicrosoftAspNetCoreODataQuerySearchQueryOptionRead;
        selectExpand?: MicrosoftAspNetCoreODataQuerySelectExpandQueryOptionRead;
        skip?: MicrosoftAspNetCoreODataQuerySkipQueryOptionRead;
        skipToken?: MicrosoftAspNetCoreODataQuerySkipTokenQueryOptionRead;
        top?: MicrosoftAspNetCoreODataQueryTopQueryOptionRead;
        validator?: MicrosoftAspNetCoreODataQueryValidatorIoDataQueryValidator;
    };
